import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { FormikContext } from "formik";
import {
  Headline,
  Text,
  WidgetCardsContainer,
  ButtonPrimary,
} from "../../common";
import * as S from "./PainelResultados.Style";
import {
  applyKey,
  distinctArray,
  mapToOptions,
  parseISO,
  parseStringDate,
} from "../../../utils";
import PremiosSorteados from "../PremiosSorteados";

const PainelResultados = ({ resultados, datasSorteios, plano }) => {
  const { setFieldValue, submitForm } = useContext(FormikContext);

  const [selectedDates, setSelectedDates] = useState([]);
  const [anoResultado, setAnoResultado] = useState("");
  const [dataFormatada, setdataFormatada] = useState("");

  useEffect(() => {
    if (resultados?.data_extracao) {
      const dataExtracao = parseISO(resultados.data_extracao);
      setAnoResultado(dataExtracao.getFullYear());
      setdataFormatada(parseStringDate(dataExtracao));
    }
  }, [resultados]);

  useEffect(() => {
    if (datasSorteios) {
      const arrayDates = [...datasSorteios]
        .map((dataSorteio) => parseISO(dataSorteio))
        .reverse();
      setSelectedDates(arrayDates);
    }
  }, [datasSorteios]);

  const selectAnos = useMemo(
    () =>
      mapToOptions(
        distinctArray(
          selectedDates.map((dataSorteio) => dataSorteio.getFullYear())
        )
      ),
    [selectedDates]
  );

  const selectDatasSorteios = useMemo(
    () =>
      mapToOptions(
        selectedDates
          .filter(
            (dataSorteio) =>
              dataSorteio.getFullYear() === parseInt(anoResultado, 10)
          )
          .map((data) => ({
            label: data.toLocaleDateString("pt-br", {
              month: "2-digit",
              day: "2-digit",
            }),
            value: data.toISOString(),
          }))
      ),
    [anoResultado, selectedDates]
  );

  const onSelectDataBusca = useCallback(
    (evtDate) => {
      const dataExtracao = [...datasSorteios].find((dataSorteio) =>
        evtDate.includes(dataSorteio)
      );

      setFieldValue("dataBusca", dataExtracao);

      if (dataExtracao) {
        submitForm();
      }
    },
    [datasSorteios, setFieldValue, submitForm]
  );

  return (
    <>
      <Headline nivel="2" styleAs="5">
        Resultado dos sorteios
      </Headline>
      <Text>Selecione o ano e a data do sorteio</Text>
      <S.FormContent>
        <S.FormDataSorteios>
          <S.SelectDate
            options={selectAnos}
            label="Ano"
            name="Ano da data do sorteio"
            onChange={({ currentTarget: { value } }) => setAnoResultado(value)}
          />
          <S.SelectDate
            options={selectDatasSorteios}
            label="Data do sorteio"
            name="Dia e mês do sorteio"
            onChange={({ currentTarget: { value } }) =>
              onSelectDataBusca(value)
            }
          />
        </S.FormDataSorteios>
      </S.FormContent>
      <Headline nivel="3" styleAs="8" text={_.capitalize(plano?.label)} />
      <S.DateText textSize="sm">Data do sorteio</S.DateText>
      <Text>{dataFormatada}</Text>
      <WidgetCardsContainer>
        {applyKey(
          resultados.combinacoes,
          ({
            combinacoes_sorteadas: combinacoes,
            descricao_premio: descricao,
          }) => (
            <S.PremiosSorteados
              as={PremiosSorteados}
              combinacoes={combinacoes}
              descricao={descricao}
            />
          )
        )}
      </WidgetCardsContainer>
      <S.NewRequestButton as={ButtonPrimary} elementType="input" type="reset">
        Fazer nova consulta
      </S.NewRequestButton>
    </>
  );
};

PainelResultados.propTypes = {
  resultados: PropTypes.objectOf(Object).isRequired,
  datasSorteios: PropTypes.arrayOf(PropTypes.string).isRequired,
  plano: PropTypes.shape({
    label: PropTypes.string,
  }),
};

PainelResultados.propTypes = {
  resultados: PropTypes.objectOf(Object).isRequired,
  datasSorteios: PropTypes.arrayOf(PropTypes.string).isRequired,
  plano: PropTypes.shape({
    label: PropTypes.string,
  }).isRequired,
};

export default PainelResultados;
